<template>
  <vxe-modal v-model="visible" title="button.editLocation" type="confirm" width="60%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="location" :rules="rules" :wrapper-col="{span:16}" style="margin-left: -2%;margin-right: 2%">
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationNo')" prop="no">
            <vxe-input v-model="location.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationName')" prop="name">
            <vxe-input v-model="location.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.storageRoom')" prop="storageRoom.name">
            <vxe-input v-model="location.storageRoom.name" :editable="false" style="width: 100%" @clear="onStorageRoomChange([])" @click="onStorageRoomSelect"/>
          </a-form-model-item>
          <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.zone')" prop="zone.name">
            <vxe-input v-model="location.zone.name" :editable="false" style="width: 100%" @clear="onZoneChange([])" @click="onZoneSelect"/>
          </a-form-model-item>
          <zone-modal ref="zoneModal" @change="onZoneChange"/>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.region')">
            <vxe-select v-model="location.region.id" :options="regions" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.roadway')" prop="roadway">
            <vxe-input v-model="location.roadway" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.row')" prop="x">
            <vxe-number-input v-model="location.x" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.layer')" prop="y">
            <vxe-number-input v-model="location.y" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.column')" prop="z">
            <vxe-number-input v-model="location.z" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.depth')" prop="depth">
            <vxe-number-input v-model="location.depth" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.section')">
            <vxe-input v-model="location.rack.section" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.side')">
            <vxe-input v-model="location.rack.side" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.length')" prop="dimension.length">
            <vxe-number-input v-model="location.dimension.length" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.width')" prop="dimension.width">
            <vxe-number-input v-model="location.dimension.width" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.height')" prop="dimension.height">
            <vxe-number-input v-model="location.dimension.height" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.volume')" prop="dimension.volume">
            <vxe-number-input v-model="location.dimension.volume" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.weight')" prop="weight">
            <vxe-number-input v-model="location.weight" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.shortNo')">
            <vxe-input v-model="location.shortNo" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationType')" prop="locationType">
            <vxe-select v-model="location.locationType" :options="locationTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationStatus')" prop="locationStatus">
            <vxe-select v-model="location.locationStatus" :options="locationStatus" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.rackType')" prop="rackType">
            <vxe-select v-model="location.rackType" :options="rackTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.storageType')" prop="storageType">
            <vxe-select v-model="location.storageType" :options="storageTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="存放类型上限" prop="limitOfStorageType">
            <vxe-number-input v-model="location.limitOfStorageType" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.pileupType')" prop="pileupType">
            <vxe-select v-model="location.pileupType" :options="pileupTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.owner')" prop="owner">
            <vxe-input v-model="location.owner.name" :editable="false" style="width: 100%" @clear="onOwnerChange([])" @click="onOwnerSelect"/>
            <party-modal ref="ownerModal" title="business.label.owner" @change="onOwnerChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.saleClassification')" prop="saleClassification">
            <vxe-select v-model="location.saleClassification" :options="saleClassifications" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.conveyor')" prop="conveyor">
            <vxe-input v-model="location.conveyor.name" :editable="false" style="width: 100%" @clear="onInputChange(location,'conveyor')" @click="onConveyorSelect"/>
            <field-modal ref="conveyorModal" :no="'CONVEYOR'" :show-value="false" :title="$t('business.label.conveyor')" @change="(values)=>onInputChange(location,'conveyor',values[0])"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.locking')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.locking" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.mechanicalLocking')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.mechanicalLocking" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.containerControl')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.containerControl"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.automatic')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.automatic"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { save } from '@/api/Api'
import { WAREHOUSE } from '@/store/mutation-types'
import FieldModal from '@/views/modal/FieldModal.vue'
import PartyModal from '@/views/modal/PartyModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import { Location } from '@/api/dto/common/Location'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Zone } from '@/api/dto/common/Zone'
import { Party } from '@/api/dto/common/Party'
import { onInputChange } from '@/utils/util'

export default {
  components: { PartyModal, FieldModal, StorageRoomModal, ZoneModal },
  props: {
    regions: { type: Array, default: [] },
    locationTypes: { type: Array, default: [] },
    locationStatus: { type: Array, default: [] },
    rackTypes: { type: Array, default: [] },
    storageTypes: { type: Array, default: [] },
    pileupTypes: { type: Array, default: [] },
    saleClassifications: { type: Array, default: [] }
  },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      location: new Location(),
      rules: {
        no: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'storageRoom.name': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'zone.name': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        x: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        y: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        z: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.length': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.width': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.height': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.volume': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        locationType: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        storageType: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        pileupType: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        saleClassification: [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    onInputChange,
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true })
    },
    onStorageRoomChange(values) {
      this.location.storageRoom = new StorageRoom(values[0])
      this.location.zone = new Zone()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.id': this.location.storageRoom.id })
    },
    onZoneChange(values) {
      this.location.zone = new Zone(values[0])
    },
    onOwnerSelect() {
      this.$refs.ownerModal.open({ available: true, 'type.ordinal': 1 })
    },
    onOwnerChange(values) {
      this.location.owner = new Party(values[0])
    },
    onConveyorSelect() {
      this.$refs.conveyorModal.open()
    },
    add() {
      this.edit()
      this.location.available = true
    },
    edit(record) {
      this.visible = true
      this.location = new Location(record)
    },
    save() {
      this.loading = true
      const location = this.location.toJSONObject()
      location.warehouse = this.warehouse
      save('locationPersister', location).then(res => {
        if (res.success) {
          this.location = new Location(res.result)
          this.$message.success('保存成功')
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    enable(record, available) {
      this.location = new Location(record)
      this.location.available = available
      this.save()
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.save()
        }
      })
    }
  }
}
</script>